import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'src/store/store';
import Sheet from '@amzn/meridian/sheet';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import closeTokens from '@amzn/meridian-tokens/base/icon/close-small';
import Heading from '@amzn/meridian/heading';
import {
  setIsRestrictionFormTableFilterSheetOpen,
  setRestrictionFormTableFilter,
  applyRestrictionFormTableFilter,
  resetRestrictionFormTableFilter,
} from 'src/store/adminConfigPageSlice/regionTasksPageSlice/regionTasksPageSlice';
import FilterDropdown from 'src/components/shared/filterDropdown/filterDropdown';

/**
 * Restriction Form Config Filter Sheet
 */
const RestrictionFormConfigFilterSheet = () => {
  const dispatch = useDispatch();

  const { isRestrictionFormTableFilterOpen, restrictionFormTableFilter, restrictionFormTableFilterOptions } =
    useAppSelector((state) => state.regionTasksConfigPage);

  const close = useCallback(() => {
    dispatch(setIsRestrictionFormTableFilterSheetOpen(false));
  }, [dispatch]);

  const reset = useCallback(() => {
    dispatch(resetRestrictionFormTableFilter());
  }, [dispatch]);

  const apply = useCallback(() => {
    dispatch(applyRestrictionFormTableFilter());
    dispatch(setIsRestrictionFormTableFilterSheetOpen(false));
  }, [dispatch]);

  // Return
  return (
    <Sheet type="overlay" side="end" open={isRestrictionFormTableFilterOpen} onClose={close}>
      <Column spacing="500" height={250} minWidth={400}>
        {/* Header */}
        <Row widths={['grid-10', 'grid-2']}>
          <Heading level={4}>Filter Restrictions</Heading>
          <Button onClick={close} type="icon">
            <Icon tokens={closeTokens}>Close sheet</Icon>
          </Button>
        </Row>

        {/* Filters */}
        <Column spacing="400">
          {/* Job Name Filter */}
          <FilterDropdown
            label="State/Region/Province"
            value={restrictionFormTableFilter.stateRegions}
            options={restrictionFormTableFilterOptions.stateRegions}
            onChange={(val) =>
              dispatch(
                setRestrictionFormTableFilter({
                  ...restrictionFormTableFilter,
                  stateRegions: val,
                }),
              )
            }
          />

          {/* Applicable Country */}
          <FilterDropdown
            label="Applicable Country"
            value={restrictionFormTableFilter.applicableCountries}
            options={restrictionFormTableFilterOptions.applicableCountries}
            onChange={(val) =>
              dispatch(
                setRestrictionFormTableFilter({
                  ...restrictionFormTableFilter,
                  applicableCountries: val,
                }),
              )
            }
          />

          {/* Type Filter */}
          <FilterDropdown
            label="Form Name"
            value={restrictionFormTableFilter.formNames}
            options={restrictionFormTableFilterOptions.formNames}
            onChange={(val) =>
              dispatch(
                setRestrictionFormTableFilter({
                  ...restrictionFormTableFilter,
                  formNames: val,
                }),
              )
            }
          />

          {/* Is Active Filter */}
          <FilterDropdown
            label="Is Active?"
            value={restrictionFormTableFilter.isActiveSelections}
            options={restrictionFormTableFilterOptions.isActiveSelections}
            onChange={(val) =>
              dispatch(
                setRestrictionFormTableFilter({
                  ...restrictionFormTableFilter,
                  isActiveSelections: val,
                }),
              )
            }
          />

          <br />
          <Row alignmentHorizontal="center">
            <Button type="secondary" onClick={reset}>
              Reset
            </Button>
            <Button onClick={apply}>Apply</Button>
          </Row>
        </Column>
      </Column>
    </Sheet>
  );
};

export default RestrictionFormConfigFilterSheet;
